import {
  FlowIcon,
  // ProfileIcon,
  SuitCaseIcon,
  FilledPersonRectangleIcon,
  GlobeIcon,
  TasksIcon,
  // TasksIcon,
  CalendarViewIcon
} from "../../Assets/icons";
import {SelfServicesPermissions} from "../../permissions/SelfServices.Permissions";
import {ConsoleMdi} from "../../Assets/icons/Console.Icon";

export const SelfServiceDashboardCardsEnum = {
  ApprovalTracking: {
    key: 1,
    title: "approvals-tracking",
    description: "approvals-tracking-desc",
    icon: FlowIcon,
    action_text: "view-all",
    action_icon: "mdi mdi-arrow-right-thin",
    route: "approvals-tracking",
  },
  // MyRequests: {
  //   key: 2,
  //   title: "my-profile",
  //   description: "my-profile-desc",
  //   icon: ProfileIcon,
  //   action_text: "view-all",
  //   action_icon: "mdi mdi-arrow-right-thin",
  //   route: "my-profile",
  // },
  Tasks: {
    key: 2,
    title: "tasks",
    description: "tasks-desc",
    icon: TasksIcon,
    action_text: "view-all",
    action_icon: "mdi mdi-arrow-right-thin",
    route: "tasks",
  },
  JobRequisitions: {
    key: 3,
    title: "job-requisition",
    description: "job-requisition-desc",
    icon: FilledPersonRectangleIcon,
    action_text: "view-all",
    action_icon: "mdi mdi-arrow-right-thin",
    defaultPermissions: {
      WorkflowApprovals: SelfServicesPermissions.WorkflowApprovals,
      NONBudgetedRequisition: SelfServicesPermissions.NONBudgetedRequisition,
    },
    route: "job-requisition",
  },
  // VisaRequests: {
  //   key: 4,
  //   title: "visa-requests",
  //   description: "visa-requests-desc",
  //   icon: GlobeIcon,
  //   action_text: "view-all",
  //   action_icon: "mdi mdi-arrow-right-thin",
  //   route: "visa-requests",
  //   defaultPermissions: {
  //     RequestVisaReservation: SelfServicesPermissions.RequestVisaReservation,
  //     ViewVisaReservation: SelfServicesPermissions.ViewVisaReservation,
  //     ViewVisaAllocation: SelfServicesPermissions.ViewVisaAllocation,
  //   },
  // },
  SharedResume: {
    key: 4,
    title: "shared-resumes",
    description: "shared-resume-desc",
    icon: GlobeIcon,
    action_text: "view-all",
    action_icon: "mdi mdi-arrow-right-thin",
    route: "shared-resume",
    // defaultPermissions: {
    //   RequestVisaReservation: SelfServicesPermissions.RequestVisaReservation,
    //   ViewVisaReservation: SelfServicesPermissions.ViewVisaReservation,
    //   ViewVisaAllocation: SelfServicesPermissions.ViewVisaAllocation,
    // },
  },
  InternalVacancies: {
    key: 5,
    title: "jobs",
    description: "internal-vacancies-desc",
    icon: SuitCaseIcon,
    action_text: "view-all",
    action_icon: "mdi mdi-arrow-right-thin",
    permissionId: SelfServicesPermissions.InternalVacancies.key, // TODO: Diana: check later
    route: "internal-vacancies", // TODO: Diana: check later
  },
  JobTracker: {
    key: 6,
    title: "job-tracker",
    description: "job-tracker-desc",
    icon: ConsoleMdi,
    action_text: "view-all",
    action_icon: "mdi mdi-arrow-right-thin",
    permissionId: SelfServicesPermissions.InternalVacancies.key, // TODO: Diana: check later
    route: "jobs-tracking",
  },
  Scorecards: {
    key: 7,
    title: "scorecards",
    description: "scorecards-desc",
    icon: CalendarViewIcon,
    action_text: "view-all",
    action_icon: "mdi mdi-arrow-right-thin",
    route: "scorecards",
  },
};
